import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables or fallbacks
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC2jPj1uw8-VcpirAyLAVzqXdFcifb0LWU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "naewaste.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "naewaste",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "naewaste.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "179288729712",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:179288729712:web:3bcb0f171a269e066cecb5",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-QY4QRELBWH"
};

// Log configuration for debugging (without sensitive values)
console.log('Firebase configuration:', {
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  usingEnvVars: !!process.env.REACT_APP_FIREBASE_API_KEY
});

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  throw error;
}

export { app };

// Initialize Firestore
let db;
try {
  db = getFirestore(app);
  console.log('✅ Firestore initialized successfully');
} catch (error) {
  console.error('❌ Firestore initialization failed:', error);
  throw error;
}

export { db };

// Initialize Auth
let auth;
try {
  auth = getAuth(app);
  console.log('✅ Firebase Auth initialized successfully');
} catch (error) {
  console.error('❌ Firebase Auth initialization failed:', error);
  throw error;
}

export { auth };

// Configure Storage with special settings for local development
const isLocalDevelopment = window.location.hostname === 'localhost' || 
                           window.location.hostname === '127.0.0.1';

// Initialize Storage directly - no custom options as they cause issues
export const storage = getStorage(app);

// Log environment and storage information
console.log('Firebase storage bucket:', storage.app.options.storageBucket);
console.log('Current environment:', isLocalDevelopment ? 'local development' : 'production'); 